import { render, staticRenderFns } from "./HistorialRecibos.vue?vue&type=template&id=6c287acc&scoped=true"
import script from "./HistorialRecibos.vue?vue&type=script&lang=js"
export * from "./HistorialRecibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c287acc",
  null
  
)

export default component.exports